import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';
import { ADDED_BY_ID } from "../../../Constants";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { useDispatch, useSelector } from "react-redux";
import { loadMaterialGroupClassificationDropdownData, postMaterialGroupDatas } from "../../../redux/action";

const statusOptions = [
    { value: 91, label: "Active" },
    { value: 92, label: "Inactive" }
]

const ratingOptions = [
    { value: 1, label: 1 },
    { value: 2, label: 2 },
    { value: 3, label: 3 },
    { value: 4, label: 4 },
    { value: 5, label: 5 },
]

const AddMaterialGroup = (props) => {

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyID = signInDetails ? signInDetails[0].CompanyID : null;

    let dispatch = useDispatch();

    const materialGroupDatas = props.materialGroupDatas;
    const singleMaterialGroupData = props.singleMaterialGroupData;
    const materialGroupID = props.materialGroupID;
    const { materialGroupClassificationDropdownData } = useSelector((state) => state.data);

    const [materialGroup, setMaterialGroup] = useState({
        MaterialGroupCode: "",
        Name: "",
        Description: "",
        ClassificationID: "",
        Ratings: null,
        StatusID: null,
        CompanyID: storedCompanyID,
        AddedByID: ADDED_BY_ID,
    })

    const [errors, setErrors] = useState({
        MaterialGroupCode: "",
        Name: "",
        Description: "",
        ClassificationID: "",
        Ratings: null,
    });

    useEffect(() => {
        dispatch(loadMaterialGroupClassificationDropdownData());
    }, []);

    useEffect(() => {
        if (materialGroupID && singleMaterialGroupData?.length > 0) {
            const materialGroupData = singleMaterialGroupData[0];
            setMaterialGroup({
                MaterialGroupID: materialGroupID,
                MaterialGroupCode: materialGroupData.MaterialGroupCode || "",
                Name: materialGroupData.MaterialGroupName || "",
                Description: materialGroupData.Description || "",
                ClassificationID: materialGroupData.ClassificationID || "",
                Ratings: materialGroupData.Ratings || "",
                CompanyID: materialGroupData.CompanyID,
                AddedByID: ADDED_BY_ID,
                StatusID: materialGroupData.StatusID || null
            });
        }
    }, [materialGroupID, singleMaterialGroupData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setMaterialGroup((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "" // Clear error on typing
        }));
    };

    const handleSelectChange = (selectedOption, field) => {
        setMaterialGroup((prevData) => ({
            ...prevData,
            [field]: selectedOption ? selectedOption.value : null,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [field]: "" // Clear error on selecting
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!materialGroup.MaterialGroupCode) newErrors.MaterialGroupCode = "required!";
        if (!materialGroup.Name) newErrors.Name = "required!";
        if (!materialGroup.Description) newErrors.Description = "required!";
        if (!materialGroup.ClassificationID) newErrors.ClassificationID = "required!";
        if (!materialGroup.Ratings) newErrors.Ratings = "required!";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const AddMaterialGroupData = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify(materialGroup),
            };
            dispatch(postMaterialGroupDatas(requestOption, props.handleCloseModal, materialGroupID, materialGroupDatas));
            console.log(materialGroup, 'materialGroup');
        }
    };

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className='add-customer-modal add-role-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>{materialGroupID ? "Edit Material Group" : "Add Material Group"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Material Group Code <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            name="MaterialGroupCode"
                                            value={materialGroup.MaterialGroupCode}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.MaterialGroupCode && <div className="text-danger">{errors.MaterialGroupCode}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Material Group Name<span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            name="Name"
                                            value={materialGroup.Name}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.Name && <div className="text-danger">{errors.Name}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Material Group Description <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            name="Description"
                                            value={materialGroup.Description}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.Description && <div className="text-danger">{errors.Description}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Classification <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={materialGroupClassificationDropdownData}
                                            placeholder="Select"
                                            value={materialGroupClassificationDropdownData.find(option => option.value === materialGroup.ClassificationID) || null}
                                            onChange={(selected) => handleSelectChange(selected, "ClassificationID")}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {errors.ClassificationID && <div className="text-danger">{errors.ClassificationID}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>Rating <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={ratingOptions}
                                            placeholder="Select"
                                            value={ratingOptions.find(option => option.value === materialGroup.Ratings) || null}
                                            onChange={(selected) => handleSelectChange(selected, "Ratings")}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                    {errors.Ratings && <div className="text-danger">{errors.Ratings}</div>}
                                </Col>
                                {materialGroupID && <Col md={4}>
                                    <div>
                                        <label>Status <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={statusOptions}
                                            placeholder="Select"
                                            value={statusOptions.find(option => option.value === materialGroup.StatusID) || null}
                                            onChange={(selected) => handleSelectChange(selected, "StatusID")}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>}
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddMaterialGroupData} />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddMaterialGroup;
